
import { defineComponent } from "vue";
export default defineComponent({
  mounted(){
    // setInterval(()=>{
    //   this.addVibration(document.querySelector('#portfolio-btn'));
    // },7000)
  },
  methods:{
    addVibration(element: HTMLElement | null) {
  element.classList.add('vibrate-1');
  setTimeout(() => {
    element.classList.remove('vibrate-1');
  }, 2000);
  }
  }

});
